import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';

/**
 * BannerCarouselSkeleton
 *
 * Matches BannerCarousel's outer dimensions:
 * - Height: { xs: 200, sm: 280, md: 400, lg: 450 }
 * - borderRadius: '0 0 16px 16px' (bottom corners only)
 *
 * Renders while the real banner data is loading.
 */
function BannerCarouselSkeleton() {
  const theme = useTheme();

  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: 200, sm: 280, md: 400, lg: 450 },
        borderRadius: '0 0 16px 16px',
        overflow: 'hidden',
        mb: 0,
        boxShadow: theme.shadowsExt?.md ?? '0 8px 20px rgba(15,23,42,0.08)',
      }}
    >
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: '0px',
          transform: 'none',
          // Subtle gradient tint via action.hover on top of the Skeleton bg
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: theme.palette.action.hover,
          },
        }}
      />
    </Box>
  );
}

export default BannerCarouselSkeleton;
